// extracted by mini-css-extract-plugin
export default {"phone":"480px","tablet":"768px","laptop":"1200px","desktop":"1800px","main":"Main_main__vAkWa"};